export const BRIDGE_DROPDOWN_CONTENT_CLASSNAME =
  'w-[350px] [@media(max-width:400px)]:w-[315px] max-h-72 p-2';
